/* ==========================================================================
   KiddoJoy - Kacheln: Sterne und Sofortkauf
   --------------------------------------------------------------------------
   Zwei kleine Aufgaben, beide auf jeder Seite mit Produktkacheln:

   1. Sterne unter dem Produktnamen, gerechnet aus assets/kj-ratings.js.
   2. Der Knopf "In den Warenkorb" legt per Fetch in den Warenkorb, ohne die
      Seite zu verlassen. Faellt das Skript aus, sendet das Formular ganz
      normal ab und Shopify laedt die Warenkorbseite. Es geht also nichts
      verloren, wenn JavaScript fehlt.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------- Sterne --- */

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2c.5 0 .9.3 1.1.8l1.9 4.2 4.5.5c1.1.1 1.5 1.4.7 2.1l-3.4 3 1 4.5c.2 1.1-1 1.9-1.9 1.3L12 17.2l-3.9 2.4c-.9.6-2.1-.2-1.9-1.3l1-4.5-3.4-3c-.8-.7-.4-2 .7-2.1l4.5-.5 1.9-4.2c.2-.5.6-.8 1.1-.8Z"/></svg>';

  function sterne(avg, n) {
    var reihe = '';
    for (var i = 0; i < 5; i++) reihe += '<i>' + STAR + '</i>';
    return '<span class="rv-stars rv-stars--xl card__stars" style="--fill:' + (avg / 5 * 100).toFixed(1) + '%">' +
             '<span class="rv-stars__row rv-stars__row--off">' + reihe + '</span>' +
             '<span class="rv-stars__row rv-stars__row--on">' + reihe + '</span>' +
           '</span><span class="card__rating-n">(' + n + ')</span>';
  }

  /* Der Produktname im Shop und der Name in der Bewertungsdatei muessen sich
     nicht Zeichen fuer Zeichen gleichen. "Lernturm 3-in-1 mit Tafel" findet
     also den Eintrag "Lernturm". */
  function treffer(titel, tabelle) {
    if (tabelle[titel]) return tabelle[titel];
    /* Erster Treffer in der Reihenfolge der Tabelle. */
    var t = titel.toLowerCase(), keys = Object.keys(tabelle);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] !== '*' && t.indexOf(keys[i].toLowerCase()) !== -1) return tabelle[keys[i]];
    }
    return null;
  }

  function zeigeSterne() {
    var tabelle = window.KJ_RATINGS;
    if (!tabelle) return;

    Array.prototype.forEach.call(document.querySelectorAll('[data-kj-rating]'), function (el) {
      var eintrag = treffer(el.getAttribute('data-kj-rating') || '', tabelle);
      if (!eintrag || !eintrag.n) return;
      el.innerHTML = sterne(eintrag.a, eintrag.n);
      el.setAttribute('aria-label', eintrag.a.toFixed(1).replace('.', ',') + ' von 5 Sternen aus ' + eintrag.n + ' Bewertungen');
      el.hidden = false;
    });
  }

  /* -------------------------------------------------------- Kurze Meldung -- */

  var toast;
  function melde(text, link) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'kj-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span class="kj-toast__tick" aria-hidden="true">' +
      '<svg viewBox="0 0 16 16"><path d="M6.4 11.6 3.2 8.4l1.1-1.1 2.1 2.1 5-5L12.5 5.5Z"/></svg></span>' +
      '<span>' + text + '</span>' +
      (link ? '<a href="' + link + '">Zum Warenkorb</a>' : '');
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 4200);
  }

  function zaehlerAktualisieren(anzahl) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      el.textContent = anzahl;
      el.hidden = anzahl === 0;
    });
  }

  /* ------------------------------------------------------------ Sofortkauf */

  function haenge(form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;                 // ohne Fetch: normaler Versand
      e.preventDefault();

      var btn = form.querySelector('button');
      var label = form.querySelector('.card__btn-label');
      var alt = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Wird gelegt …';

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (artikel) {
          melde(artikel.product_title + ' liegt im Warenkorb.', '/cart');
          if (label) label.textContent = 'Noch eines';
          if (btn) { btn.disabled = false; btn.classList.add('is-done'); }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r ? r.json() : null; })
        .then(function (warenkorb) { if (warenkorb) zaehlerAktualisieren(warenkorb.item_count); })
        .catch(function () {
          if (label) label.textContent = alt;
          if (btn) btn.disabled = false;
          form.submit();                          // im Zweifel der normale Weg
        });
    });
  }

  function start() {
    zeigeSterne();
    Array.prototype.forEach.call(document.querySelectorAll('form[data-quick-add]'), function (f) {
      if (f.hasAttribute('data-bound')) return;
      f.setAttribute('data-bound', '');
      haenge(f);
    });
  }
  /* Der Warenkorb tauscht seinen Inhalt ohne Neuladen aus. Danach muessen
     Sterne und Knoepfe in den neuen Kacheln noch einmal verdrahtet werden. */
  window.KJ_refreshStars = start;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
